import React, { useEffect, useState } from "react";
import "./style.css";

import TextInput from "../TextInput";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay, useDisclosure } from "@chakra-ui/react";
import { LinkIcon } from "../../../Assets/images/svgs";

const PopUpModal = ({ modalMsg, closeBtn, confirmBtn, open, onModalClose, onConfirm, size, footer, showInput, inputCover, placeholder, hasError, darken, bodyClass, confirmIcon }) => {
  const [inputValue, setInputValue] = useState("");

  const { onClose } = useDisclosure();

  const handleModalClose = () => {
    onClose();
    onModalClose();
  };

  useEffect(() => {
    setInputValue("");
  }, [open])

  return (
    <div>
      <Modal isOpen={open} onClose={handleModalClose} isCentered size={size || "md"} >
        <ModalOverlay bg={darken ? 'blackAlpha.900' : 'blackAlpha.600'} />
        <ModalContent className="modal-content">
          {/* <ModalCloseButton /> */}
          <ModalBody className={`modal-body ${bodyClass}`}>
            {modalMsg}
          </ModalBody>

          <ModalFooter className={`modal-footer ${footer}`}>
            {showInput ? (
              <TextInput
                inputCover={inputCover}
                placeholder={placeholder}
                onChange={(val) => setInputValue(val)}
                errMessage={hasError}
              />
            ) : ""}
            <div className="modal-btn-grp">
              {closeBtn && (
                <Button onClick={handleModalClose} className="popup-modal-close-button">
                  {closeBtn}
                </Button>
              )}
              {confirmBtn && (
                <Button variant="ghost" onClick={() => onConfirm(inputValue)} leftIcon={confirmIcon ? <LinkIcon /> : ""} className="popup-modal-confirm-button">
                  {confirmBtn}
                </Button>
              )}
            </div>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

PopUpModal.propTypes = {
  open: PropTypes.bool,

  size: PropTypes.string,
  modalMsg: PropTypes.oneOfType([ PropTypes.string, PropTypes.element, PropTypes.number ]),
  footer: PropTypes.string,
  showInput: PropTypes.bool,
  inputCover: PropTypes.string,
  placeholder: PropTypes.string,

  closeBtn: PropTypes.string,
  confirmBtn: PropTypes.string,
  onConfirm: PropTypes.func,
  onModalClose: PropTypes.func,

  hasError: PropTypes.oneOfType([ PropTypes.string, PropTypes.bool ]),
};

export default PopUpModal;
